// Import order is important here. Domus must be imported after others to avoid error.
import { createMyApp } from './main';

import App from './AppHg.vue';

import { SupportedPlatforms } from '@smg-real-estate/domus';

export const createApp = createMyApp(App, SupportedPlatforms.hg);
